import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 8a4 4 0 0 1 7.732-1.444l1.865-.723A6.006 6.006 0 0 0 8 2a6 6 0 1 0 0 12c.819 0 1.77-.26 2.621-.755l.21.524c.46 1.15 2.169.82 2.169-.418v-3.226C13 9.504 12.496 9 11.875 9H8.53c-1.188 0-1.565 1.6-.504 2.131l1.181.59c-.44.19-.874.279-1.207.279a4 4 0 0 1-4-4Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgArrowBackwards = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgArrowBackwards;
